import { render, staticRenderFns } from "./PersonalReport_CR.vue?vue&type=template&id=07c0230a&scoped=true&"
import script from "./PersonalReport_CR.vue?vue&type=script&lang=js&"
export * from "./PersonalReport_CR.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReport_CR.vue?vue&type=style&index=0&id=07c0230a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c0230a",
  null
  
)

export default component.exports